import { lazy } from 'react'

const PicoViewAsync = lazy(() => {
    return import(/* webpackChunkName: "Pico" */ './PicoView')
})

export default PicoViewAsync
